export default __webpack_public_path__ + "2b2f4426eabae860dc898a707ff85b7e.png";